export default __webpack_public_path__ + "static/media/commission.9fa0a785.svg";